/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormStateSnapshot, queryFormMode, State } from '@gh/common-shared';
import { FormMode, STYLES_FLEX_COLUMN_LAYOUT } from '@gh/core-ui';
import { Observable } from 'rxjs';
import { LeadContactDetails, LeadMasterInfo } from '../../../resources/lead.model';
import { LeadDetailsCommandService } from '../lead-details-command.service';
import { LeadDetailsState, queryLeadMasterInfo } from '../lead-details.state';

@Component({
  standalone: false,
  selector: 'gh-lead-details-dc-tab',
  templateUrl: 'lead-details-dc-tab.component.html',
  styles: [STYLES_FLEX_COLUMN_LAYOUT],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeadDetailsDcTabComponent implements OnInit {
  mode$: Observable<FormMode>;
  masterInfo$: Observable<FormStateSnapshot<LeadMasterInfo>>;

  constructor(private state: State<LeadDetailsState>,
              private commands: LeadDetailsCommandService) {
  }

  ngOnInit(): void {
    this.mode$ = this.state.select(queryFormMode);
    this.masterInfo$ = this.state.select(queryLeadMasterInfo);
  }

  onMasterInfoChange(masterInfo: FormStateSnapshot<LeadMasterInfo>): void {
    this.commands.setMasterInfo(masterInfo);
  }

  onCreateContact(): void {
    this.commands.createContact();
  }

  onOpenContact(contact: LeadContactDetails): void {
    this.commands.openContact(contact);
  }

  onSelectContact(contact: LeadContactDetails): void {
    this.commands.selectContact(contact);
  }
}
